import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';
import { UtilService, NotificationService, TranslationService, DialogService } from '../../shared/index';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileService } from '../shared/profile.service';

@Component({
  selector: 'wl-profile-type-icon',
  templateUrl: 'profile-type-icon.component.html',
  standalone: false
})
export class ProfileTypeIconComponent implements OnInit {
  @Input() public isMember: boolean = false;
  @Input() public isOrg: boolean = false;
  @Input() public profileId: number = 0;
  @Input('cssClass') public moreClass: string;
  @Input() public memberTypeIconColor: string = '';
  @Input('styleOverrides') public moreStyle: any;

  public _utilService: UtilService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _route: ActivatedRoute;
  public _profileService: ProfileService;
  public _dialogService: DialogService;

  public imageSrcPath: string;

  private _switchProfileIconThrottleTimeoutId: number = 0;

  public constructor(
    utilService: UtilService,
    notifyService: NotificationService,
    translationService: TranslationService,
    route: ActivatedRoute,
    profileService: ProfileService,
    dialogService: DialogService
  ) {
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._route = route;
    this._profileService = profileService;
    this._dialogService = dialogService;

    this.imageSrcPath = '';
    this.memberTypeIconColor = '';
    this.moreStyle = {};
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['isMember'] && changes['isMember'].currentValue != changes['isMember'].previousValue) ||
      (changes['isOrg'] && changes['isOrg'].currentValue != changes['isOrg'].previousValue) ||
      (changes['profileId'] && changes['profileId'].currentValue != changes['profileId'].previousValue)
    ) {
      // throttle so it doesn't call every time in the same digest cycle
      window.clearTimeout(this._switchProfileIconThrottleTimeoutId);

      if (this.memberTypeIconColor) this.switchProfileIcon();
      else this._switchProfileIconThrottleTimeoutId = window.setTimeout(() => this.switchProfileIcon(), 150);
    }
  }

  /**
   * query the server for this profiles member icon
   */
  private switchProfileIcon(): void {
    var resultPromise: Promise<string> = Promise.resolve('');

    // if passed in, don't hit api
    if (this.memberTypeIconColor) {
      resultPromise = Promise.resolve(this.memberTypeIconColor);
    } else if (this.isMember && this.profileId > 0) {
      // save some network traffic. only check the service this profile is a member
      resultPromise = this._profileService.getMemberIconColor(this.profileId);
    }

    resultPromise.then((data: string) => {
      this.memberTypeIconColor = data;
      if (this.isMember) {
        if (this.isOrg) {
          switch (this.memberTypeIconColor) {
            case 'Blue':
              this.imageSrcPath = '/assets/img/iconOrganizationalMember_blue.png';
              break;
            case 'Green':
              this.imageSrcPath = '/assets/img/iconOrganizationalMember_green.png';
              break;
            case 'Purple':
              this.imageSrcPath = '/assets/img/iconOrganizationalMember_purple.png';
              break;
            case 'Yellow':
              this.imageSrcPath = '/assets/img/iconOrganizationalMember_yellow.png';
              break;
            default:
              this.imageSrcPath = '/assets/img/iconOrganizationalMember.png';
          }
        } else {
          switch (this.memberTypeIconColor) {
            case 'Blue':
              this.imageSrcPath = '/assets/img/iconIndividualMember_blue.png';
              break;
            case 'Green':
              this.imageSrcPath = '/assets/img/iconIndividualMember_green.png';
              break;
            case 'Purple':
              this.imageSrcPath = '/assets/img/iconIndividualMember_purple.png';
              break;
            case 'Yellow':
              this.imageSrcPath = '/assets/img/iconIndividualMember_yellow.png';
              break;
            default:
              this.imageSrcPath = '/assets/img/iconIndividualMember.png';
          }
        }
      } else {
        if (this.isOrg) {
          this.imageSrcPath = '/assets/img/iconOrganizationalProfile.png';
        } else {
          this.imageSrcPath = '/assets/img/iconIndividualProfile.png';
        }
      }
    });
  }
}
